<template lang="pug">
    div.meditationItem

        // Meditation name
        div.meditationName {{ item.title }}

        // Send Date
        div
            date-picker(
                :predefinedDate="startDate"
                :label="$t('fields.showDate')"
                :datePickerCallback="startDateCallback"
            )

        // Send time
        div
            time-picker(
                :predefinedTime="startTime"
                :label="$t('fields.showTime')"
                :timePickerCallback="startTimeCallback"
            )

        div
            v-checkbox(
                v-model="item.isLocked"
                label="Locked"
            )

        // Drug icon
        div
            v-icon(color="white") unfold_more
</template>

<script>
    import DatePicker from '~components/Picker/DatePicker';
    import TimePicker from '~components/Picker/TimePicker';
    import dayjs from 'dayjs';
    import VueTypes from 'vue-types';
    import { mapActions } from 'vuex';

    export default {
        components: {
            TimePicker,
            DatePicker
        },
        props: {
            item: VueTypes.object.def({})
        },
        computed: {
            startDate() {
                return dayjs(this.item.showAt).format('YYYY-MM-DD');
            },
            startTime() {
                if (this.item.showAt) {
                    return dayjs(this.item.showAt).format('HH:mm');
                }

                return dayjs().format('HH:mm');
            }
        },
        watch: {
            ['item.isLocked'](val, oldVal) {
                if (val === oldVal) return;

                this.triggerLockedMeditation({ id: this.item.id, value: val });
            }
        },
        methods: {
            ...mapActions('businesses', [
                'addLaunchDate',
                'triggerLockedMeditation'
            ]),
            startDateCallback(date) {
                this.setDateTime(date, this.startTime);
            },
            startTimeCallback(time) {
                this.setDateTime(this.startDate, time);
            },

            setDateTime(date, time) {
                const dateTime = dayjs(`${date} ${time}`);
                this.addLaunchDate({
                    id: this.item.id,
                    date: dateTime,
                    routingKey: 'meditation'
                });
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../../../assets/style/_variables.styl'

    .meditationItem
        display: flex
        align-items: center
        justify-content: space-between
        padding: 5px 15px
        margin: 5px 0
        border: 1px solid rgba($theme.white, 0.5)
        background: $theme.primary

    .meditationName
        width: 240px
        overflow: hidden
        text-overflow: ellipsis
</style>
